

















































import { Vue,Component, Watch } from 'vue-property-decorator'
import { State,Action,namespace } from 'vuex-class'
import exicon from '../../assets/js/expressicon'
const financial = namespace('financial')
@Component
export default class Home extends Vue{
    exicon:any = exicon
    payTypeIndex:number = 0
    daterange:any = [] //入库时间断
    multipleSelection:any = [] //勾选的项
    form:any = {
        type: '',
        month: '',
        project: ''
    }
    @financial.State('cashWaterPager') cashWaterPager:any //表格的页码
    @financial.State('cashWaterList') cashWaterList:any //流水列表
    @financial.State('loading') loading:any 
    @State('dictionaries') dictionaries:any
    search:any = {
        site: '',
        type: '',
        project: '',
        month: '',
        star: '',
        end: '',
        pageSize: 20,
        page: 1
    } 
    rules:any = {
        type:[{ required: true, message: '业务类型不能为空'}],
        month:[{ required: true, message: '归属月份不能为空'}],
        project:[{ required: true, message: '项目不能为空'}]
    }
    get formOptions(){
        return [{
            label: '业务类型',
            prop: 'type',
            type: 'slot',
            ruleType: 'text'
        },{
            label: '归属月份',
            prop: 'month',
            type: 'slot',
            ruleType: 'text'
        },{
            label: '项目',
            prop: 'project',
            type: 'slot',
            ruleType: 'text'
        }]
    }
    get project(){
        const type = this.search.type;
        const payType = this.dictionaries.payType;
        let children = [];
        for(const item of payType){
            if(item.name === type){
                children = item.children
            }
        }
        return children;
    }
    get tablecolumn(){
        return [
            {
                prop: 'siteName',
                type: 'text',
                label: '网点',
            },
            {
                prop: 'orderid',
                type: 'text',
                label: '订单号',
                width: '240px'
            },
            {
                name: 'type',
                type: 'slot',
                label: '类型',
            },
            {
                name: 'project',
                type: 'slot',
                label: '项目',

            },
            {
                prop: 'partner',
                name: 'partner',
                type: 'slot',
                label: '快递员',

            },
            {
                prop: 'cash',
                type: 'text',
                label: '金额(元)',

            },
            {
                prop: 'month', 
                type: 'text',
                label: '归属月份',

            },
            {
                prop: 'ctime',
                type: 'text',
                label: '付款时间',
                width: '160px'
            },
            {
                prop: 'desc',
                type: 'text',
                label: '备注',

            },
            {
                prop: 'name',
                name:'operation',
                type: 'slot',
                label: '操作',
            }
        ]
    }
    @financial.Action('getCashWaterList') getCashWaterList:any
    @financial.Action('restDetail') restDetail:any
    @Action('getDictionaries') getDictionaries:any
     @Action('exportCash') exportCash:any
    
    created(){
        this.getDictionaries()
        this.getList()
    }
    getList(){
        this.getCashWaterList(this.search)
    }
    // 勾选前面的选项时
    multiplechange(e:any){
        this.multipleSelection = e
    }
    // 翻页
    pagechange(e:any){
        this.search.page = e[0].val
        this.getList()
    }
    // 更改页数
    pageSizechange(e:any){
        this.search.pageSize = e[0].val
        this.getList()
    }
    // 导出数据
    async exportexcel(){
        // this.exportCash();
        const data = this.multipleSelection
        if(data.length < 1) return this.$message.error('选择需要导出的数据')
        require.ensure([], () => {
            const { export_json_to_excel } = require('../../assets/vendor/Export2Excel');
            const tHeader = ['网点','类型','项目','快递员','金额', '归属月份','时间','备注'];
            const p = [tHeader]
            data.map((item:any)=>{
                p.push([item.siteName, item.type, item.project || '未定义',item.partner ? item.partner.name : '未找到',item.cash,item.month,item.ctime, item.desc])
            })
            const pk = [{
                sheetName:"付款流水统计",
                data:p
            }];
            const extitle = `付款流水导出`
            export_json_to_excel(pk,extitle);
        })
    }
    // 重置明细
    async restDetailRow(id:string){
       const res = await this.restDetail(id);
        if(res){
            await this.getList()
            this.$message({
                message: '重置成功',
                type: 'success'
            });
        }
    }
    // 网点改变的时候
    changeSite(val:string){
        this.search.site = val
        this.getList()
    }
    @Watch('daterange')
    daterangeChange(val:string,oldVal:string){
        this.search.star = val[0]
        this.search.end = val[1]
    }
    @Watch('search.type')
    payTypeChange(val:string,oldVal:string){
        this.dictionaries.payType.forEach((item:any,index:number) => {
            if(item.code == val){
                this.payTypeIndex = index
                return
            }
        })
    }
    @Watch('form.type')
    payTypeChangeLayer(val:string,oldVal:string){
        this.dictionaries.payType.forEach((item:any,index:number) => {
            if(item.code == val){
                this.payTypeIndex = index
                return
            }
        })
    }
}
